export default __webpack_public_path__ + "static/media/book.0ad32569.png";